import React from "react"
import {
    Button,
    Dropdown,
    Flex,
    Input,
    RadioGroup,
    Text
} from "@fluentui/react-northstar"
import {
    IAudienceFormData,
    IDropDownData 
} from "./Types"

export interface IAudienceProps {
    audienceForm: IAudienceFormData;
    targetSelectedChange: any;
    selectedUsersChanged: any;
    selectedTeamsChanged: any;
    selectedRostersChanged: any;
    selectedGroupChanged: any;
}

export default function Audience(props: IAudienceProps) {
    const propsCopy: IAudienceProps = props;

    return (
        <Flex className="scrollableContent">
            <Flex.Item size="size.half">
                <Flex column className="formContentContainer">
                    <h3>Elija cómo desea enviar el mensaje</h3>
                    
                    <RadioGroup
                        className="radioBtns"
                        checkedValue={props.audienceForm.targetSelected}
                        onCheckedValueChange={props.targetSelectedChange}
                        vertical={true}
                        items={[
                            {
                                name: "users",
                                key: "users",
                                value: "users",
                                label: "Enviar a usuarios específicos",
                                children: (Component, { name, ...props }) => {
                                    return (
                                        <Flex key={name} column>
                                            <Component {...props} />
                                            <Dropdown
                                                hidden={!propsCopy.audienceForm.isUsersTargetSelected}
                                                placeholder="Seleccionar usuario(s)"
                                                search
                                                multiple
                                                items={propsCopy.audienceForm.allUsers}
                                                value={propsCopy.audienceForm.selectedUsers}
                                                loading={propsCopy.audienceForm.usersLoading}
                                                loadingMessage="Cargando..."
                                                getA11ySelectionMessage={{
                                                    onAdd: item => propsCopy.selectedUsersChanged(item, "+"),
                                                    onRemove: item => propsCopy.selectedUsersChanged(item, "-")
                                                }}
                                                noResultsMessage="No hemos podido encontrar ninguna coincidencia."
                                            />
                                        </Flex>
                                    )
                                },
                            },
                            {
                                name: "teams",
                                key: "teams",
                                value: "teams",
                                label: "Enviar al Canal general de equipos específicos",
                                children: (Component, { name, ...props }) => {
                                    return (
                                        <Flex key={name} column>
                                            <Component {...props} />
                                            <Dropdown
                                                hidden={!propsCopy.audienceForm.isTeamsTargetSelected}
                                                placeholder="Seleccionar equipo(s)"
                                                search
                                                multiple
                                                items={propsCopy.audienceForm.allTeams}
                                                value={propsCopy.audienceForm.selectedTeams}
                                                loading={propsCopy.audienceForm.teamsLoading}
                                                loadingMessage="Cargando..."
                                                getA11ySelectionMessage={{
                                                    onAdd: item => propsCopy.selectedTeamsChanged(item, "+"),
                                                    onRemove: item => propsCopy.selectedTeamsChanged(item, "-")
                                                }}
                                                noResultsMessage="No hemos podido encontrar ninguna coincidencia."
                                            />
                                        </Flex>
                                    )
                                },
                            },
                            {
                                name: "rosters",
                                key: "rosters",
                                value: "rosters",
                                label: "Enviar en chat a los miembros de los siguientes equipos",
                                children: (Component, { name, ...props }) => {
                                    return (
                                        <Flex key={name} column>
                                            <Component {...props} />
                                            <Dropdown
                                                hidden={!propsCopy.audienceForm.isRostersTargetSelected}
                                                placeholder="Seleccionar equipo(s)"
                                                search
                                                multiple
                                                items={propsCopy.audienceForm.allTeams}
                                                value={propsCopy.audienceForm.selectedRosters}
                                                getA11ySelectionMessage={{
                                                    onAdd: item => propsCopy.selectedRostersChanged(item, "+"),
                                                    onRemove: item => propsCopy.selectedRostersChanged(item, "-")
                                                }}
                                                // unstable_pinned={this.state.unstablePinned}
                                                noResultsMessage="No hemos podido encontrar ninguna coincidencia."
                                            />
                                        </Flex>
                                    )
                                },
                            },
                            {
                                name: "allUsers",
                                key: "allUsers",
                                value: "allUsers",
                                label: "Enviar en chat a todos",
                                children: (Component, { name, ...props }) => {
                                    return (
                                        <Flex key={name} column>
                                            <Component {...props} />
                                        </Flex>
                                    )
                                },
                            },
                            {
                                name: "groups",
                                key: "groups",
                                value: "groups",
                                label: "Enviar en chat a los miembros del siguiente grupo de M365, de distribución o de seguridad",
                                children: (Component, { name, ...props }) => {
                                    return (
                                        <Flex key={name} column>
                                            <Component {...props} />
                                            <Input className="inputField"
                                                value={propsCopy.audienceForm.selectedGroup}
                                                onChange={propsCopy.selectedGroupChanged}
                                                hidden={!propsCopy.audienceForm.isGroupTargetSelected}
                                                autoComplete="off"
                                                fluid
                                            />
                                        </Flex>
                                    )
                                },
                            }
                        ]}
                    >

                    </RadioGroup>

                </Flex>
            </Flex.Item>
            <Flex.Item size="size.half">
                <div className="adaptiveCardContainer">
                </div>
            </Flex.Item>
        </Flex>
    )
}
